export const CoorporateType = {
  PRE_PAID: "prepaid",
  POST_PAID: "postpaid",
  NONE: "None",
};

export const Role = {
  ADMIN: "Corporate Admin",
  SUPER_ADMIN: "Super Admin",
  CORPORATE_USER: "Corporate User",
};

export const OTPAction = {
  VERIFY_USER_OTP: "verify_user_otp",
  RESEND_USER_OTP: "resend_user_otp",
  INITIATE_ADMIN_OTP: "initiate_admin_otp",
  VERIFY_ADMIN_OTP: "verify_admin_otp",
  APPROVE: "approve",
  REJECT: "reject",
  RESEND_ADMIN_OTP: "resend_admin_otp",
  REJECT_BY_USER: "reject_by_user",
  CORPORATE_APPROVE: "corporate_approve",
};
